import { StylesConfig } from 'react-select';

export const getCompactSelectStyles = (): StylesConfig => ({
  container: (base, { isDisabled }) => ({
    ...base,
    pointerEvents: 'all',
    fontSize: '14px',
    lineHeight: '20px',
    cursor: isDisabled
      ? "url('@/shared/assets/images/cursors/notAllowed.svg'), not-allowed"
      : 'default',
  }),
  control: (base, { isFocused, isDisabled, selectProps }) => {
    const borderColor = selectProps['aria-invalid']
      ? 'var(--redrose)'
      : 'rgba(var(--bg3-rgb), .2)';

    return {
      ...base,
      pointerEvents: isDisabled ? 'none' : 'all',
      minHeight: 36,
      borderRadius: 8,
      backgroundColor: 'transparent',
      borderColor: isFocused ? 'var(--purpleflat)' : borderColor,
      borderWidth: 1,
      boxShadow: 'none',
      cursor: 'pointer',
      ':hover': {
        borderColor: selectProps['aria-invalid']
          ? 'var(--redrose)'
          : 'var(--purpleflat)',
      },
    };
  },
  valueContainer: (base) => ({
    ...base,
    padding: '4px 12px',
    margin: 0,
  }),
  dropdownIndicator: (base, { isDisabled, selectProps }) => {
    const indicatorColor = selectProps['aria-invalid']
      ? 'var(--redrose)'
      : 'var(--bw)';

    return {
      ...base,
      padding: '4px',
      margin: '0 6px 0 0',
      color: isDisabled ? 'var(--greytext)' : indicatorColor,
      ':hover': {
        color: 'var(--purpleflat)',
      },
    };
  },
  clearIndicator: (base) => ({
    ...base,
    padding: '4px',
    marginRight: 4,
    color: 'var(--greytext)',
    ':hover': {
      color: 'var(--redrose)',
    },
  }),
  menu: (base) => ({
    ...base,
    backgroundColor: 'var(--wtop)',
    borderRadius: 8,
    overflow: 'hidden',
    boxShadow: 'var(--menu-shadow)',
  }),
  menuList: (base) => ({
    ...base,
    padding: 4,
  }),
  option: (base) => ({
    ...base,
    padding: '8px 12px',
    borderRadius: 6,
    backgroundColor: 'transparent',
    color: 'var(--bw)',
    cursor: 'pointer',
    ':hover': {
      backgroundColor: 'rgba(var(--purpleflat-rgb), 0.06)',
    },
    ':active': {
      backgroundColor: 'rgba(var(--purpleflat-rgb), 0.1)',
    },
    ':not(:last-child)': {
      marginBottom: 2,
    },
  }),
});
